import prismjs from "prismjs";
import "prismjs/components/prism-java.js";
import "prismjs/components/prism-groovy.js";
export function getGrammar(lang = "none") {
    const grammar = prismjs.languages[lang];
    if (!grammar) {
        return getGrammar("plain");
    }
    return { grammar, lang, className: `language-${lang}` };
}
export function highlight(code, grammar, lang) {
    return prismjs.highlight(code, grammar, lang);
}
